import { render, staticRenderFns } from "./NewAddrModal.vue?vue&type=template&id=32183f15&"
import script from "./NewAddrModal.vue?vue&type=script&lang=js&"
export * from "./NewAddrModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports